import { auth, signInWithEmailAndPassword } from './firebase.js'

export default {
    async login(email, password) {
        return signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          // Signed in 
          const user = userCredential.user;
          // ...
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
        });
    }
}